import drawEn from './draw/en.json';
import drawZhHant from './draw/zh-Hant.json';
import drawVi from './draw/vi.json';
import drawTh from './draw/th.json';

export default {
  en: drawEn,
  'zh-Hant': drawZhHant,
  vi: drawVi,
  th: drawTh,
};
